import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { ProcessoService } from '@app/services/processo.service';
import { MinhaAgenda } from '@app/models/minha-agenda';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

@Component({
  selector: 'app-audiencia-lista',
  templateUrl: './audiencia-lista.component.html',
  styleUrls: ['./audiencia-lista.component.scss']
})
export class AudienciaListaComponent implements OnInit {

  processoId: number;
  lstAgenda: MinhaAgenda[];
  exibirBtn: boolean = false;
  bsModalRef: BsModalRef;
  processoArquivado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private processoService: ProcessoService,
  ) {
    this.lstAgenda = [];
  }

  ngOnInit() {
    this.router.events.subscribe(() => window.scrollTo(0, 0));

    this.route.parent.params.subscribe(
      (params) => {
        this.processoId = params['id'];
        this.obterMovimentacao();
      });

    var data: any = this.route.data;
    if (data.value.exibirBtn)
      this.exibirBtn = true;

  }

  obterMovimentacao() {
    this.processoService.obterAudienciaPorProcesso(this.processoId)
      .subscribe(data => this.lstAgenda = data);
  }

  deletar(audiencia: MinhaAgenda) {

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente deletar a audiência: " + audiencia.Descricao;
    this.bsModalRef.content.confirmar = () => {
      this.processoService.deletarAudiencia(audiencia.Id).subscribe(() => this.obterMovimentacao());
    }

  }

}
